import { useEffect, useState } from 'react';
import { useThemeContext } from '@honda-canada/design-system-react';
import { GLOBAL_NAV_MOBILE_HEIGHT } from '../../utils/constants';
import { getStickyOffset } from './utils/constants';
import { useAppSelector } from '../../core/utils';
const useDetectSticky = (isExtended, shouldOverrideMobileHeader) => {
    const theme = useThemeContext();
    const stickyOffset = getStickyOffset(isExtended);
    const [isSticky, setIsSticky] = useState(false);
    const SCROLL_THRESHOLD = 35;
    const { dealerBannerHeight } = useAppSelector(state => state.ui.SelectedDealerBanner);
    useEffect(() => {
        const handleScroll = () => {
            setIsSticky(window.scrollY > SCROLL_THRESHOLD);
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const calculateDesktopTopValue = () => {
        const height = parseFloat(theme.header.desktop.height);
        const stickyHeight = parseFloat(theme.header.desktop.stickyHeight);
        // TODO: deprecate 'extended' related logics
        if (isExtended) {
            return stickyOffset.desktop;
        }
        return isSticky ? stickyHeight + stickyOffset.desktop : height + stickyOffset.desktop;
    };
    const stickyPosition = {
        desktop: calculateDesktopTopValue(),
        mobile: shouldOverrideMobileHeader
            ? 0
            : stickyOffset.mobile + parseInt(GLOBAL_NAV_MOBILE_HEIGHT, 10) + dealerBannerHeight,
    };
    return { stickyPosition, isSticky };
};
export default useDetectSticky;
